import React from 'react'
import { MenuItem, Position } from '@blueprintjs/core'
import { Select2 } from '@blueprintjs/select'
import { Button, IconButton } from '..'
import ClearableSelectWrapper from './ClearableSelectWrapper'
import { IUIButtonProps } from '../buttons/Button'
import { Role } from '@api'

interface RoleSelectProps {
  value: Role | null
  disabled?: boolean
  btnText?: string
  clearable?: boolean
  onChange: (role: Role | null) => void
  buttonProps?: IUIButtonProps
}

const RoleSelect = Select2<Role>

export default function RoleSelectWrapper({
  value,
  disabled,
  clearable,
  onChange,
  buttonProps,
  btnText,
}: RoleSelectProps) {
  return (
    <ClearableSelectWrapper>
      <RoleSelect
        filterable={false}
        popoverProps={{
          minimal: true,
          position: Position.BOTTOM,
          disabled,
        }}
        items={Object.values(Role)}
        itemRenderer={(role: Role, { handleClick }) => (
          <MenuItem
            key={role}
            data-button={role}
            active={role === value}
            onClick={handleClick}
            text={getRoleLabel(role)}
          />
        )}
        onItemSelect={onChange}
      >
        <Button
          {...buttonProps}
          disabled={disabled}
          rightIconName={value ? undefined : 'chevron-down'}
          text={value ? getRoleLabel(value) : btnText || 'Select'}
        />
      </RoleSelect>
      {value && clearable && (
        <IconButton
          minimal
          data-button="clear-button"
          iconName="times"
          tooltip="Clear"
          onClick={() => onChange(null)}
        />
      )}
    </ClearableSelectWrapper>
  )
}

export function getRoleLabel(role: Role) {
  const roleLabels = {
    [Role.ADMIN]: 'Admin',
    [Role.DEPARTMENT_ADMIN]: 'Department Admin',
    [Role.LOCATION_ADMIN]: 'Location Admin',
    [Role.POWER_ADMIN]: 'Power Admin',
    [Role.IT]: 'IT',
    [Role.VIEWER]: 'Viewer',
    [Role.SPACE_CAPTAIN]: 'Space Captain',
    [Role.BOOKINGS_MANAGER]: 'Booking Manager',
  }
  return roleLabels[role]
}
